import { getIsWidget } from 'js/helpers/page-data';
import {
  MPInitOptions,
  MPUserIdentities,
  mParticleInit,
  mParticleLogEvent,
  mParticleEventType,
} from '@treatwell/ui';
import {
  getDeviceId,
  growthbookInitialiseClient,
} from '@treatwell/growthbook-js/client';
import { twEnvTypeValue, isTest } from './helpers/environment';
import { getClientGrowthbookConfig } from '../js/growthbook/growthbook-config';
import { configureSentry } from './sentry-config';

let growthbookResolve: (value: any) => void;
const growthbookPromise = new Promise((resolve) => {
  growthbookResolve = resolve;
});

export function getGrowthbook() {
  return growthbookPromise;
}

export async function initialiseCoreLibraries() {
  const channel = window.__state__.channel;
  const accountDetails = window.__state__.accountDetails;
  const isAuthenticated =
    accountDetails.loginStatus === 'account_authenticated';

  const growthbookConfig = getClientGrowthbookConfig(twEnvTypeValue);
  const deviceId = await getDeviceId();

  initMParticle(deviceId);
  configureSentry();

  const growthbook = await growthbookInitialiseClient(
    growthbookConfig,
    deviceId,
    {
      growthbookAttributes: {
        channel: {
          country: channel.country.countryCode,
        },
        user: {
          account_id: String(accountDetails.accountId),
          is_authenticated: isAuthenticated,
        },
      },
      deferredTrackingCalls: window.deferredTrackingCalls,
      activationEvent: {
        type: 'mparticle',
        send(defaultAttributes) {
          mParticleLogEvent(
            '$experiment_started',
            mParticleEventType.Other,
            defaultAttributes
          );
        },
      },
    }
  );

  growthbookResolve(growthbook);
}

async function initMParticle(deviceId: string) {
  const isWidget = getIsWidget(window.__state__);
  const accountDetails = window.__state__.accountDetails;
  if (isWidget || isTest()) {
    return;
  }

  try {
    const [mParticle, mParticleOneTrust] = await Promise.all([
      import(/* webpackChunkName: "mparticle_web-sdk" */ '@mparticle/web-sdk'),
      import(
        /* webpackChunkName: "mparticle_web-onetrust-kit" */ '@mparticle/web-onetrust-kit'
      ),
    ]);

    const options: MPInitOptions = {
      isDevelopmentMode: twEnvTypeValue !== 'prod',
      deviceId,
    };
    const { accountId, email } = accountDetails;
    const userIdentities: MPUserIdentities = {};

    mParticleOneTrust.register(options);

    if (accountId) {
      userIdentities.customerid = `${accountId}`;

      if (email) {
        userIdentities.email = email;
      }
    }

    mParticleInit(mParticle.default, options, userIdentities);
  } catch (error) {
    console.error('Error initializing mParticle:', error);
  }
}
